import { Item } from './Item';
import { Product } from '@interfaces';
import { Fragment } from 'react';
import { Console } from '@utils';

import {
  RootDiv,
  DivisionLine,
  SubTitleTypography,
} from '../styles/ItemsList.styles';

interface ItemsListProps {
  productsByPrescription: [string, Product[]][];
}
const prescriptionName = {
  NOT_REQUIRED: 'Receta simple',
  HELD: 'Receta retenida',
  SIMPLE: 'Receta simple',
  CHECK: 'Receta cheque',
};

export function ItemsList(props: ItemsListProps) {
  const { productsByPrescription } = props;
  Console.log('productsByPrescription', productsByPrescription);
  return (
    <RootDiv isDelivery>
      {productsByPrescription?.map((item, index: number) => {
        return (
          <Fragment key={index}>
            <SubTitleTypography>
              {prescriptionName[item?.[0]]}
            </SubTitleTypography>
            <DivisionLine />
            {item?.[1]?.map((product: Product, index: number) => {
              return (
                <Item
                  key={index}
                  product={product}
                  price={product.price}
                  quantity={+product.quantity}
                />
              );
            })}
          </Fragment>
        );
      })}
    </RootDiv>
  );
}
